import { Radio } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useState } from 'react';

export default function SelectSubTopic({
  selectedTheme,
  selectedSubTopic,
  setSelectedSubTopic,
}) {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [descToggle, setDescToggle] = useState({});
  return (
    <div className='max-w-2xl mt-8'>
      {selectedSubTopic ? (
        <div className='border border-gray-300 rounded flex items-center p-2'>
          <span className='text-green-c1 font-semibold px-2'>
            {selectedTopic.name}
          </span>
          <span className='mx-2'>-</span>
          <span className='font-semibold opacity-60'>
            {selectedSubTopic.name}
          </span>

          <span className='flex-grow' />

          <button
            onClick={() => {
              setSelectedSubTopic(null);
              setSelectedTopic(null);
            }}
            className='px-8 py-2 bg-green-c1 text-white font-medium rounded focus:outline-none'
          >
            CHANGE
          </button>
        </div>
      ) : (
        selectedTheme.topics.map((topic) => (
          <div className='border border-gray-300 rounded p-4' key={topic.id}>
            <div className='text-green-c1 text-lg font-semibold px-2 rounded-t-lg mb-4'>
              {topic.name}
            </div>
            {topic.subTopics.map((subTopic) => (
              <div className='opacity-60 font-medium px-2' key={subTopic.id}>
                <div className='flex'>
                  <span
                    className='cursor-pointer text-lg'
                    onClick={() =>
                      setDescToggle({ [subTopic.id]: !descToggle[subTopic.id] })
                    }
                  >
                    <span className='mr-2'>{subTopic.name}</span>
                    {descToggle[subTopic.id] ? <ExpandLess /> : <ExpandMore />}
                  </span>

                  <span className='flex-grow' />
                  <Radio
                    checked={selectedSubTopic?.id === subTopic.id}
                    onChange={() => {
                      setSelectedSubTopic(subTopic);
                      setSelectedTopic(topic);
                    }}
                    color='primary'
                  />
                </div>

                {descToggle[subTopic.id] && (
                  <div>
                    <div className='text-gray-500 text-sm max-w-3xl -mt-2 text-justify pr-8'>
                      {subTopic.description}
                    </div>
                    <div className='text-gray-400 text-sm mb-6 mt-2'>
                      Duration: {subTopic.duration || 'N/A'} minutes
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}
